module.exports = __webpack_public_path__ + "img/back kick pleat length.7b2e00a9.png";